import type { StoreApi, UseBoundStore } from 'zustand';
import i18n from '../i18n';

type EntityStore = UseBoundStore<StoreApi<any>>;

/**
 * 從列表 store 移除符合條件的項目（樂觀更新：新增失敗回滾、刪除客戶／專案後清掉連帶刪除的資料）
 */
export const removeItemsWhere = <T>(store: EntityStore, predicate: (item: T) => boolean) => {
  store.setState((state: any) => {
    const items = (state.items as T[]).filter(item => !predicate(item));
    const removed = state.items.length - items.length;
    return {
      items,
      pagination: state.pagination
        ? { ...state.pagination, totalItems: Math.max(0, state.pagination.totalItems - removed) }
        : null,
      lastOptimisticUpdate: Date.now(),
    };
  });
};

/** 各列表 store 共用的刪除訊息（common.messages.*） */
export const entityStoreMessages = {
  deleteSuccess: () => i18n.t('common.messages.deleteSuccess'),
  deleteError: () => i18n.t('common.messages.deleteFailed'),
  fetchError: () => i18n.t('common.messages.fetchFailed'),
};
